import React, {useEffect, useState} from 'react'
import {useParams, useHistory} from 'react-router-dom'
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import MenuMember from "../components/menuMember"
import TitleH1 from "../components/titleH1"
import TileH3 from "../components/titleH3"
import Table from "../components/table"
import DivWhite from "../components/divWhite"
import CheckBox from "../components/checkbox"
import ButtonForm from "../components/buttonForm"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import HorizontalAlign from "../components/horizontalAlign"
import Settings from '../assets/settings.png'
import Image from "../components/image"
import TitleH3 from "../components/titleH3";
import Paypal from "../components/paypal";
import TitleH2 from "../components/titleH2";
import List from "../components/list";
import Button from "../components/button";
import Text from "../components/text";

const ClubView = props => {
    const params = useParams()
    const [club, setClub] = useState({})
    const [upToDate, setUpToDate] = useState(false)
    const [licences, setLicences] = useState([])
    const [checked, setChecked] = useState([])
    const [paypal, setPaypal] = useState(false)

    const history = useHistory()

    const countChecked = async () => {
        const checkboxes = document.getElementsByTagName('input')
        for (let i = 1; i < checkboxes.length; i++) if (checkboxes[i].checked) return 1
        return 0
    }

    const checkAll = async event => {
        const checkboxes = document.getElementsByTagName('input')
        let checkTemp = []

        if (event.target.checked) {
            for (let i = 1; i < checkboxes.length; i++) {
                checkTemp.push(checkboxes[i].name)
                checkboxes[i].checked = true
            }
            setChecked(await checkTemp)
        } else {
            for (let i = 1; i < checkboxes.length; i++) checkboxes[i].checked = false
            setChecked(await checkTemp)
        }
    }

    const handleCheck = async event => {
        if (event.target.checked) setChecked(await [...checked, event.target.name])
        else setChecked(await checked.filter(licence => licence !== event.target.name))

        if (await countChecked() === 0) document.getElementById("check").checked = false
    }

    useEffect(() => {
        const fetchClub = async () => {
            const res = await props.actions.club.getOne(params.id)
            if (res) setClub(res)
            else history.push('/profile')
        }
        fetchClub()
    }, [props.actions.club, params.id, history])

    useEffect(() => {
        const fetchLicencesClub = async () => {
            setLicences(await props.actions.licence.getLicencesByClub({id: params.id, idClubs: params.id}))
        }
        fetchLicencesClub()
    }, [props.actions.licence, params.id])

    useEffect(() => {
        if (new Date(`${club.validite}-08-31`) >= new Date(Date.now())) {
            setUpToDate(true)
        }
    }, [club])

    return (
        <div>
            <Navbar/>
            {localStorage.getItem('admin') === "true" ? <Menu/> : <MenuMember/>}
            <HorizontalAlign content={
                <>
                    <TitleH1 content={club.nom}/>
                    <Image src={Settings} width="35px" onClick={() => history.push(`/club-settings/${club._id}`)}
                           cursor="pointer"/>
                </>
            } alignItems="center"/>
            {
                licences.length > 0 ?
                    <>
                        <DivWhite content={
                            <Table content={
                                <>
                                    <thead>
                                    <tr>
                                        <td>Prénom & nom</td>
                                        <td>Numéro</td>
                                        <td>Catégorie</td>
                                        <td>Validité</td>
                                        <td>Type</td>
                                        <td><CheckBox id="check" name="check" onChange={(e) => checkAll(e)}/></td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        licences.map(licence => {
                                            let typeLicence
                                            if (licence.typeLicence === "Compétition" || licence.typeLicence === "competition") {
                                                typeLicence = "Compétition"
                                            } else {
                                                typeLicence = "Subbuteo"
                                            }
                                            return (
                                                <tr key={licence._id}>
                                                    <td onClick={() => history.push(`/licence/${licence._id}`)}>
                                                        {licence.prenom} {licence.nom}
                                                    </td>
                                                    <td>{licence.numeroLicence}</td>
                                                    <td>{licence.categorie}</td>
                                                    <td>{licence.validite}</td>
                                                    <td>{typeLicence}</td>
                                                    <td><CheckBox name={licence._id} onChange={(e) => handleCheck(e)}/>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </>
                            } width="100%"/>
                        } width="100%"
                        />

                        {
                            (checked.length > 0) ? <ButtonForm
                                    value={`Valider ${checked.length} licence(s)`}
                                    onClick={
                                        async () => {
                                            const data = licences.filter(licence => checked.includes(licence._id))
                                            if (await props.actions.licence.dispatchLicences(data))
                                                window.location = "/recap-renewal"
                                            else alert("Impossible de récupérer les informations des licences. " +
                                                "Veuillez rafraichir la page...")
                                        }}
                                />
                                : null
                        }
                    </>
                    : <TileH3 content="Aucune licence pour ce club..."/>

            }
            <br/>
            <br/>
            {
                club.affiliation === true ?
                    <>
                        <hr/>
                        <TitleH2 content="Licence du club"/>
                        {
                            <>
                                {
                                    !upToDate ?
                                        <>
                                            <p>La licence n'est plus à jour pour ce club</p>
                                            <p>Vous pouvez la renouveler en suivant le formulaire ci-après.</p>
                                        </>
                                        :
                                        <>
                                            <p>
                                                La licence pour votre club est valable jusqu'au :
                                                <span style={{fontWeight: "bold"}}> 31/08/{club.validite}</span>.
                                            </p>
                                            <p>Vous pouvez la prolonger en suivant le formulaire ci-après.</p>
                                        </>
                                }
                                <TitleH3 content="Renouvellement" marginBottom="0"/>
                                <p>
                                    Le prix initial du renouvellement de la licence est de 40€. Plusieurs
                                    moyens de paiement sont mis à votre disposition :
                                </p>
                                <List content={
                                    <>
                                        <li>Via PayPal</li>
                                        <li>Par carte bancaire</li>
                                        <li>Par chèque (à envoyer directement à la 3fts)</li>
                                    </>
                                }/>
                                <br/>
                                <br/>

                                <p>Prix à payer : <b>40€</b></p>

                                {
                                    paypal ?
                                        <>
                                            <Text size="25px">Plusieurs moyens de paiement :</Text>
                                            <Paypal
                                                name={`Renouvellement licence pour ${club.nom}`}
                                                total={`40`}
                                                description={`Paiement pour le renouvellement de la licence de ${club.nom}`}
                                                destination={"/confirm-renewal/club"}
                                            />
                                        </> :
                                        <Button value="Procéder au renouvellement"
                                                width="auto" align="left"
                                                onClick={() => setPaypal(true)}/>
                                }
                            </>
                        }
                    </>
                    : null
            }
        </div>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ClubView)
